import React from 'react';

type TTableProps = {
    title: string;
    children: React.ReactNode;
};

const Table: React.FC<TTableProps> = ({ title, children }) => {
    return (
        <table className='mb-6 table'>
            <caption className='caption-top px-0 py-3 text-left font-bold uppercase'>{title}</caption>
            <tbody>{children}</tbody>
        </table>
    );
};

export default Table;
